import { useEffect, useRef, useState } from "react";
import { InlineWidget } from "react-calendly";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsCameraVideo } from "react-icons/bs";
import aiText from "../../Assets/AIOnDemand/ai-text-alt.png";
import phoneImage from "../../Assets/AIOnDemand/sam-phone.png";
import image from "../../Assets/TalentOnDemand/calendly-bg.png";
const BookACall = () => {
    const [calendlyModalIsOpen, setCalendlyModalIsOpen] = useState(false);
    const calendlyModalRef = useRef<any>(null);

    const handleClickOutside = (event: any) => {
        if (calendlyModalRef.current && !calendlyModalRef.current.contains(event.target)) {
            setCalendlyModalIsOpen(false);
        }
    };

    useEffect(() => {
        if (calendlyModalIsOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [calendlyModalIsOpen]);


    return (
        <section className="w-full h-full flex flex-col items-center relative justify-between gap-4">
            {
                calendlyModalIsOpen && (
                    <div className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 flex justify-center items-center md:p-[10%]">
                        <div className="bg-white md:px-0 mx-auto rounded-lg" ref={calendlyModalRef}>
                            <CalendlyWidget />
                        </div>
                    </div>
                )
            }
            <img src={image} alt="" className="w-full h-full object-cover absolute left-0 top-0" />
            <div className="px-4 lg:px-0 relative top-0 left-0 w-full ">
                <div className="flex flex-col lg:flex-row gap-10 max-w-[1400px] justify-between lg:items-end py-16 lg:px-10  mx-auto">
                    <div className="flex flex-col">
                        <h2 className="text-2xl md:text-5xl mb-2 text-white ">
                            Let’s make it happen.
                        </h2>
                        <p className="text-md lg:text-2xl text-white mb-10 font-light ">
                            Discuss how your org can automate in 30 days!
                        </p>
                        <CalendlyWidget />
                    </div>
                    <div>
                        <img src={phoneImage} alt="Phone" className=" max-h-[700px] mt-auto object-contain mx-auto lg:mx-none" />
                    </div>
                </div>
            </div>
        </section >
    );
}
const CalendlyWidget = () => {
    const calendlyLink = "https://calendly.com/salesbox-meet/salesmrkt";
        // "https://calendly.com/salesbox-meet/ai-ondemand";

    return (
        <div className="border flex-col md:flex-row  flex rounded-2xl h-fit bg-white">

            <div className=" md:flex  border-r max-w-[350px] mr-2 flex-col items-center justify-start">
                <div className="flex flex-col w-fit items-start p-6">
                    <h2 className="text-3xl text-black font-semibold  gap-2 text-center flex flex-row items-center justify-center">
                        Revenue Growth
                        <img src={aiText} alt="AI" className="max-h-8" />
                    </h2>
                    <div className="flex gap-4 items-center mt-10 justify-center">
                        <AiOutlineClockCircle className="text-2xl" />
                        <h5 className="font-bold">30 min</h5>
                    </div>
                    <div className="flex gap-4 mt-3  items-center justify-center">
                        <BsCameraVideo className="w-[20px]   h-[24px] " />
                        <div className="font-bold">
                            <h5>Web conferencing</h5>
                        </div>
                    </div>
                    <div>
                        <h4 className="text-black font-normal text-xl  text-start mt-16">
                            Meet with an AI Growth <br />Specialist to learn more                        </h4>
                    </div>
                    <a target="_blank" href={calendlyLink} className="mx-auto lg:mx-none hover:bg-transparent hover:text-black transition-all duration-200 ease-inout border border-black bg-black w-full max-w-[200px] text-center items-center flex justify-center h-12 mt-16 text-white rounded-full">Book a Call</a>
                </div>
            </div>
            <a
                href={calendlyLink}
                target="_blank"
                className="pl-1 pr-1 "
                rel="noopener noreferrer"
            >
                <div className="lg:w-[400px]" id="calendly-widget">
                    <InlineWidget
                        url={calendlyLink}
                        pageSettings={{
                            backgroundColor: "fff",
                            hideEventTypeDetails: true,
                            hideLandingPageDetails: true,
                            hideGdprBanner: true,
                            primaryColor: "#146FF8",
                            textColor: "#4d5055",
                        }}
                    />
                </div>
            </a>
        </div>
    )
}

export default BookACall;